"use client";

import { INTERNAL_LINK, PageType, StrapiMedia } from "@/types";
import styles from "@/styles/Home.module.scss";
import Link from "next/link";
import Image from "next/image";

export const HomePageLink = ({ page }: { page: PageType }) => {
	const GetImageUrl = (media: StrapiMedia, format?: "thumbnail" | "small" | "medium" | "large"): string => {
		let url: string = media.url;
		if (typeof format === "undefined") {
			return process.env.NEXT_PUBLIC_API_ORIGIN + url;
		}
		if (media.formats && media.formats[format] && media.formats[format].url) {
			url = media.formats[format].url as string;
		}

		return process.env.NEXT_PUBLIC_API_ORIGIN + url;
	};

	return (
		<Link className={styles.pageLink} href={`${INTERNAL_LINK.Subpage}/${page.slug}`}>
			<div className={styles.innerContainer}>
				<div className={styles.overlay}>
					<h2 className="translate">{page.teaserTitle}</h2>
				</div>
				{page.teaser_image && (
					<>
						<Image
							className={styles.image}
							src={GetImageUrl(page.teaser_image, "large")}
							alt={page.teaser_image.alternativeText ? page.teaser_image.alternativeText : "bua-feature bild"}
							fill
							sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
							style={{ objectFit: "cover" }}
							priority
							unoptimized
						/>
					</>
				)}
			</div>
		</Link>
	);
};
